<template>
  <div>
    <div class="relative h-12">
      <label
        :for="id"
        class="absolute top-0 left-0 ml-3 pointer-events-none text-sn-gray"
        :class="[
          isActive || placeholder ? 'mt-1 text-xs' : 'mt-3'
        ]"
      >
        {{ label }}
      </label>
      <input
        :id="id"
        v-model="inputValue"
        :placeholder="placeholder"
        :aria-label="label"
        type="text"
        class="w-full h-full px-3 pt-4 border appearance-none placeholder-sn-gray focus:outline-none focus:shadow-9"
        :class="[!valid ? 'border-sn-secondary-700 text-sn-secondary-700' : 'border-sn-primary text-sn-primary']"
        @focus="onFocus"
        @blur="onBlur"
      >
    </div>

    <p v-if="!valid" class="mt-1">
      <span class="inline-flex px-2 py-1 text-xs leading-none text-white bg-sn-secondary-700">
        {{ errorString }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    valid: {
      type: Boolean,
      required: true,
    },
    errorString: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      isFocused: false,
    }
  },
  computed: {
    isActive() {
      return this.isFocused || this.inputValue
    },
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    onBlur() {
      this.isFocused = false
      this.$emit('blur', true)
    },
    onFocus() {
      this.isFocused = true
      this.$emit('focus', true)
    },
  },
}
</script>
